/* eslint-disable */
import { useMemo } from 'react'
import styled from 'styled-components'
import { Text, Flex, CardBody, CardFooter, Button, AddIcon } from '@noahswap/uikit'
import Link from 'next/link'
import { useWeb3React } from '@noahswap/wagmi'
import { useTranslation } from '@noahswap/localization'
import FullPositionCard from '../../components/PositionCard'
import { useTokenBalancesWithLoadingIndicator } from '../../state/wallet/hooks'
import { usePairs, PairState } from '../../hooks/usePairs'
import { toV2LiquidityToken, useTrackedTokenPairs } from '../../state/user/hooks'
import Dots from '../../components/Loader/Dots'
import { AppHeader, AppBody } from '../../components/App'
import Page from '../Page'

const Body = styled(CardBody)`
  /* background-color: ${({ theme }) => theme.colors.dropdownDeep}; */
  background-color: transparent;
`

export default function Pool() {
  const { account } = useWeb3React()
  const { t } = useTranslation()

  // fetch the user's balances of all tracked V2 LP tokens
  const trackedTokenPairs = useTrackedTokenPairs()
  const tokenPairsWithLiquidityTokens = useMemo(
    () => trackedTokenPairs.map((tokens) => ({ liquidityToken: toV2LiquidityToken(tokens), tokens })),
    [trackedTokenPairs],
  )
  const liquidityTokens = useMemo(
    () => tokenPairsWithLiquidityTokens.map((tpwlt) => tpwlt.liquidityToken),
    [tokenPairsWithLiquidityTokens],
  )
  const [v2PairsBalances, fetchingV2PairBalances] = useTokenBalancesWithLoadingIndicator(
    account ?? undefined,
    liquidityTokens,
  )

  // fetch the reserves for all V2 pools in which the user has a balance
  const liquidityTokensWithBalances = useMemo(
    () =>
      tokenPairsWithLiquidityTokens.filter(({ liquidityToken }) =>
        v2PairsBalances[liquidityToken.address]?.greaterThan('0'),
      ),
    [tokenPairsWithLiquidityTokens, v2PairsBalances],
  )

  // console.log(trackedTokenPairs, 'trackedTokenPairs')
  // console.log(liquidityTokens, 'liquidityTokens')
  // console.log(v2PairsBalances, 'v2PairsBalances')
  // console.log(fetchingV2PairBalances, 'fetchingV2PairBalances')
  // console.log(liquidityTokensWithBalances, 'liquidityTokensWithBalancesliquidityTokensWithBalances')

  const v2Pairs = usePairs(liquidityTokensWithBalances.map(({ tokens }) => tokens))
  const v2IsLoading =
    fetchingV2PairBalances ||
    v2Pairs?.length < liquidityTokensWithBalances.length ||
    (v2Pairs?.length && v2Pairs.every(([pairState]) => pairState === PairState.LOADING))
  const allV2PairsWithLiquidity = v2Pairs
    ?.filter(([pairState, pair]) => pairState === PairState.EXISTS && Boolean(pair))
    .map(([, pair]) => pair)

  const renderBody = () => {
    if (!account) {
      // 您的流动性仓位将在此显示
      return (
        <Flex justifyContent="center" alignItems="center" flexDirection="column">
          <img src="/images/small-img/5555.png" alt="" width="45px" style={{ marginTop: '20px' }} />
          <Text color="textSubtle" textAlign="center" mt="20px">
            {t('noah67')}
          </Text>
        </Flex>
      )
    }
    if (v2IsLoading) {
      return (
        <Text color="textSubtle" textAlign="center">
          <Dots>{t('Loading')}</Dots>
        </Text>
      )
    }
    if (allV2PairsWithLiquidity?.length > 0) {
      return allV2PairsWithLiquidity.map((v2Pair, index) => (
        <FullPositionCard
          key={v2Pair.liquidityToken.address}
          pair={v2Pair}
          mb={index < allV2PairsWithLiquidity.length - 1 ? '16px' : 0}
        />
      ))
    }
    return (
      // 您的流动性仓位将在此显示
      <Flex justifyContent="center" alignItems="center" flexDirection="column">
        <img src="/images/small-img/5555.png" alt="" width="45px" style={{ marginTop: '20px' }} />
        <Text color="textSubtle" textAlign="center" mt="20px">
          {t('noah67')}
        </Text>
      </Flex>
    )
  }

  return (
    <Page>
      <AppBody>
        <AppHeader title={t('noah48')} subtitle="" type />
        {/* subtitle={t('Remove liquidity to receive tokens back')} */}
        <Body style={{ paddingTop: 0 }}>
          {renderBody()}
          {/* {account && !v2IsLoading && (
            <Flex flexDirection="column" alignItems="center" mt="24px">
              <Text color="textSubtle" mb="8px">
                {t("Don't see a pool you joined?")}
              </Text>
              <Link href="/find" passHref>
                <Button id="import-pool-link" variant="secondary" scale="sm" as="a">
                  {t('Find other LP tokens')}
                </Button>
              </Link>
            </Flex>
          )} */}
        </Body>
        <CardFooter style={{ textAlign: 'center' }}>
          {/* <Link href="/add" passHref> */}
          <Link href="/add">
            {/* startIcon={<AddIcon color="white" />} */}
            <Button id="join-pool-button" width="100%">
              {t('noah10')}
            </Button>
          </Link>
        </CardFooter>
      </AppBody>
    </Page>
  )
}
